import { create } from "zustand"

export type StockToPOItem = {
  product_id: string
  product_name: string
  qty_order: number
  price_measure:number
  mr_unit_id:string
}

type State = {
  item: StockToPOItem | null
  setItem: (item: StockToPOItem) => void
  clear: () => void
}

export const usePurchaseFromStockStore = create<State>((set) => ({
  item: null,
  setItem: (item) => set({ item }),
  clear: () => set({ item: null }),
}))
